
export const PRIMARY_COLOR = "#e3324b";
export const ACCENT_COLOR = "#F9A81B";
export const FONT_COLOR = "#B5B5B3";
export const FONT_COLOR_DARK = "#808080";
export const KLAY_COLOR = "#4F473C";
